module.exports = __webpack_public_path__ + "img/big.c7ff8988.jpg";